import bcrypt from "bcryptjs";

const SescService = {
  helper2: async function (userinfo) {
    const salt = bcrypt.genSaltSync(10);
    const pwd = bcrypt.hashSync(process.env.REACT_APP_USERAPI_PWD, salt);
    const user = bcrypt.hashSync(process.env.REACT_APP_USERAPI, salt);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user: user, pwd: pwd }),
    };

    const response = await fetch(
      `${process.env.REACT_APP_APICLIENTELA_URL}/clientela/login`,
      requestOptions
    );
    const data = await response.json();

    const _tokencli = data.token;

    const cpf = userinfo.cpf.match(/\d/g).join("");

    const requestOptionsCard = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": _tokencli,
      },
    };

    const resp = await fetch(
      `${process.env.REACT_APP_APICLIENTELA_URL}/clientela/card/${cpf}/`,
      requestOptionsCard
    );
    const result = await resp.json();
    return result;
  },

  helperDep: async function (userinfo) {
    const salt = bcrypt.genSaltSync(10);
    const pwd = bcrypt.hashSync(process.env.REACT_APP_USERAPI_PWD, salt);
    const user = bcrypt.hashSync(process.env.REACT_APP_USERAPI, salt);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user: user, pwd: pwd }),
    };

    const response = await fetch(
      `${process.env.REACT_APP_APICLIENTELA_URL}/clientela/login`,
      requestOptions
    );

    const data = await response.json();
    const _tokencli = data.token;
    const cpf = userinfo.cpf.match(/\d/g).join("");

    const requestOptionsCard = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": _tokencli,
      },
    };

    const resp = await fetch(
      `${process.env.REACT_APP_APICLIENTELA_URL}/clientela/${cpf}/sesc-dep`,
      requestOptionsCard
    );
    
    const result = await resp.json();
    return result;
  },


  

  helper3_dep: async function (cpfdep) {
    const salt = bcrypt.genSaltSync(10);
    const pwd = bcrypt.hashSync(process.env.REACT_APP_USERAPI_PWD, salt);
    const user = bcrypt.hashSync(process.env.REACT_APP_USERAPI, salt);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user: user, pwd: pwd }),
    };

    const response = await fetch(
      `${process.env.REACT_APP_APICLIENTELA_URL}/clientela/login`,
      requestOptions
    );
    const data = await response.json();

    const _tokencli = data.token;

    const cpf = cpfdep.match(/\d/g).join("");

    const requestOptionsCard = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": _tokencli,
      },
    };

    const resp = await fetch(
      `${process.env.REACT_APP_APICLIENTELA_URL}/clientela/card/${cpf}/`,
      requestOptionsCard
    );
    const result = await resp.json();
    return result;
  },















};

export default SescService;
